export const SET_AUTO_FILL = 'SET_AUTO_FILL';
export const LOAD_AUTO_FILL = 'LOAD_AUTO_FILL';



// WEBPACK FOOTER //
// ./src/redux/action-types/ui/setAutoFill.js